import { AppThunk } from '../../../../../../store/types';
import { IRestAudioCaption } from '../../../../../../../common/rest/audio/audioRest';
import { AudioEffects } from '../../../../../../effects/audioEffects';
import { ConferenceSettingsEvents } from '../../../../../call/ConferenceSettings/hocs/events';

export class CaptionsCompareEvents {

	// Pick a provider for the conference and swap the shown captions to that provider's set.
	// The captions are already loaded in the compare panel, so we update the store in place instead of re-fetching.
	public static onProviderChange(
		audioId: number,
		provider: string,
		captions: IRestAudioCaption[],
	): AppThunk {
		return (dispatch) => {
			dispatch(ConferenceSettingsEvents.onChange(audioId, { transcriptionProvider: provider }));
			AudioEffects.setActiveCaptions(captions);
		};
	}

}
